import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useInvalidateUseGetAgencyInformationForUser } from '@urbanx/agx.agencies.client';
import { StoreAccessCodeResponseResult, useStoreAccessCode } from '@urbanx/agx.docusign.client';
import useQuery from 'hooks/useQuery';
import getIntegrationAuthorizationReturnPath from './getIntegrationAuthorizationReturnPath';

const DocuSignAuthenticated = () => {
  const query = useQuery();
  const navigate = useNavigate();
  const invalidateAgencyInformation = useInvalidateUseGetAgencyInformationForUser();
  const returnPath = getIntegrationAuthorizationReturnPath(query.get('state'));
  const { storeAccessCode } = useStoreAccessCode({
    onSuccess: async (response) => {
      if (response?.result === StoreAccessCodeResponseResult.Success) {
        await invalidateAgencyInformation();
        navigate(returnPath, { replace: true });
        return;
      }

      const errorCode =
        response?.result === StoreAccessCodeResponseResult.InvalidAccount
          ? 'invalid-account'
          : 'connection-failed';

      navigate(`${returnPath}?docuSignErrorCode=${errorCode}`, { replace: true });
    },
    onError: () => navigate(`${returnPath}?docuSignErrorCode=connection-failed`, { replace: true }),
  });

  useEffect(() => {
    const code = query.get('code');

    if (!code) {
      navigate(`${returnPath}?docuSignErrorCode=authorization-failed`, { replace: true });
      return;
    }

    void storeAccessCode(code).catch(() => undefined);
  }, [navigate, query, returnPath, storeAccessCode]);

  return null;
};

export default DocuSignAuthenticated;
